<template>
  <div class="step-selector">
    <div
      class="step"
      :class="{ active: parseInt(currentStep) == 1 }"
      @click="isAdmin && setStep(1)"
    >
      <em>1</em>
      <span>
        <strong>Choisissez votre offre</strong>
        <img
          v-if="parseInt(currentStep) > 1 || currentStep == 'confirmation'"
          src="/wp-content/themes/id/images/classified/icon-step-checked.png"
          width="12"
          height="9"
          alt=""
        />
      </span>
    </div>
    <!-- .step -->
    <div
      class="step"
      :class="{ active: parseInt(currentStep) == 2 }"
      @click="isAdmin && setStep(2)"
    >
      <em>2</em>
      <span>
        <strong>Rédigez votre annonce</strong>
        <img
          v-if="parseInt(currentStep) > 2 || currentStep == 'confirmation'"
          src="/wp-content/themes/id/images/classified/icon-step-checked.png"
          width="12"
          height="9"
          alt=""
        />
      </span>
    </div>
    <!-- .step -->
    <div
      class="step"
      :class="{ active: parseInt(currentStep) == 3 }"
      @click="isAdmin && setStep(3)"
    >
      <em>3</em>
      <span>
        <strong>Validez votre annonce</strong>
        <img
          v-if="parseInt(currentStep) > 3 || currentStep == 'confirmation'"
          src="/wp-content/themes/id/images/classified/icon-step-checked.png"
          width="12"
          height="9"
          alt=""
        />
      </span>
    </div>
    <!-- .step -->
  </div>
  <!-- .step-selector -->
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "step-selector",
  data: function () {
    return {};
  },
  computed: {
    ...mapGetters(["currentStep", "isAdmin"]),
  },
  methods: {
    // ...mapMutations(["setStep"])
  },
};
</script>
<style lang="scss">
.isAdmin .step-selector .step {
  cursor: pointer;
}
</style>
